import { usePracticeAccess } from '@hb/react'
import { TELEPHONE_CONTACTS, TelephoneContact, USERS } from '@hb/shared'
import { collection, CollectionReference, orderBy, query, where } from 'firebase/firestore'
import { useMemo } from 'react'
import { db } from '../../../backend/db'
import { useQuery } from '../useQuery'

export const useAssessmentContacts = (
  patientId: string | null | undefined,
  assessmentId: string | null | undefined,
) => {
  const { selectedPracticeId } = usePracticeAccess()
  const ref = useMemo(() => {
    if (!assessmentId || !patientId) return null
    const col = collection(
      db,
      USERS,
      patientId,
      TELEPHONE_CONTACTS,
    ) as CollectionReference<TelephoneContact>
    if (selectedPracticeId) {
      return query(
        col,
        where('assessmentId', '==', assessmentId),
        where('practiceId', '==', selectedPracticeId),
        orderBy('date', 'desc'),
      )
    }
    return query(col, where('assessmentId', '==', assessmentId), orderBy('date', 'desc'))
  }, [assessmentId, patientId, selectedPracticeId])
  return useQuery<TelephoneContact>(ref)
}
